export const mockAutoSuggestOptions = [
  {
    term: 'helsinki',
    weight: '102'
  },
  {
    term: 'helkamäentie',
    weight: '1'
  },
  {
    term: 'helmi',
    weight: '1'
  },
  {
    term: 'helsingin',
    weight: '1'
  },
  {
    term: 'helsingintie',
    weight: '1'
  }
];

export const mockOfficeResults = [
  {
    bankNameFI: 'UUDENMAAN OSUUSPANKKI',
    bankNameSE: 'NYLANDS ANDELSBANK',
    bankNumber: '578800',
    branchNameFI: 'OP-PRIVATE HELSINKI',
    branchNameSE: 'OP-PRIVATE HELSINGFORS',
    branchNumber: '578876',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00100',
    streetAddressFI: 'ARKADIANKATU 23 C',
    streetAddressSE: 'ARKADIAGATAN 23 C'
  },
  {
    bankNameFI: 'UUDENMAAN OSUUSPANKKI',
    bankNameSE: 'NYLANDS ANDELSBANK',
    bankNumber: '578800',
    branchNameFI: 'PÄÄKONTTORI',
    branchNameSE: 'HUVUDKONTOR',
    branchNumber: '578800',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00100',
    streetAddressFI: 'ARKADIANKATU 23',
    streetAddressSE: 'ARKADIAGATAN 23'
  },
  {
    bankNameFI: 'UUDENMAAN OSUUSPANKKI',
    bankNameSE: 'NYLANDS ANDELSBANK',
    bankNumber: '578800',
    branchNameFI: 'RAHAHUOLTOKONTTORI',
    branchNameSE: 'RAHAHUOLTOKONTTORI',
    branchNumber: '578828',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'MIKONKATU 11',
    streetAddressSE: 'MIKONKATU 11'
  },
  {
    bankNameFI: 'KEHI-POHJOLA-PANKKI',
    bankNameSE: 'KEHI-POHJOLA-BANK',
    bankNumber: '580228',
    branchNameFI: 'PÄÄKONTTORI',
    branchNameSE: 'HUVUDKONTOR',
    branchNumber: '580228',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'TEOLLISUUSKATU 1',
    streetAddressSE: 'INDUSTRIGATAN 1'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'POHJOLA',
    branchNameSE: 'POHJOLA',
    branchNumber: '500001',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'TEOLLISUUSKATU 1 B',
    streetAddressSE: 'INDUSTRIGATAN 1 B'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'OKO-RUNEBERG',
    branchNameSE: 'OKO-RUNEBERG',
    branchNumber: '500080',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'TEOLLISUUSKATU 1 B',
    streetAddressSE: 'ARKADIANKATU 23'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'MAASEUTURAHOITUSPALVELUT',
    branchNameSE: 'MAASEUTURAHOITUSPALVELUT',
    branchNumber: '592028',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'RITVA TANNINEN F7',
    streetAddressSE: 'RITVA TANNINEN F7'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'ULKOMAISET SÄILYTYKSET',
    branchNameSE: 'ULKOMAISET SÄILYTYKSET',
    branchNumber: '593139',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'ARKADIANKATU 23',
    streetAddressSE: 'ARKADIANKATU 23'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'RAHOITUSYHTIÖPALVELUT',
    branchNameSE: 'RAHOITUSYHTIÖPALVELUT',
    branchNumber: '593142',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'OSUUSPANKKIKESKUS /E6',
    streetAddressSE: 'OSUUSPANKKIKESKUS /E6'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'MAKSULIIKEPALVELUT',
    branchNameSE: 'MAKSULIIKEPALVELUT',
    branchNumber: '593220',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'TEOLLISUUSKATU 1',
    streetAddressSE: 'TEOLLISUUSKATU 1'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'OPNET1',
    branchNameSE: 'OPNET1',
    branchNumber: '593530',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'TEOLLISUUSKATU 1',
    streetAddressSE: 'TEOLLISUUSKATU 1'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'YRITYSTEN VERKKOKONTTORI',
    branchNameSE: 'YRITYSTEN VERKKOKONTTORI',
    branchNumber: '593561',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'TEOLLISUUSKATU 1',
    streetAddressSE: 'TEOLLISUUSKATU 1'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'OPSTOCK-EMISSIOT',
    branchNameSE: 'OPSTOCK-EMISSIOT',
    branchNumber: '593868',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00510',
    streetAddressFI: 'TEOLLISUUSKATU 1 B',
    streetAddressSE: 'INDUSTRIGATAN 1 B'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'OKO-EMISSIOT',
    branchNameSE: 'OKO-EMISSIOT',
    branchNumber: '593915',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00100',
    streetAddressFI: 'ARKADIANKATU 23',
    streetAddressSE: 'ARKADIANKATU 23'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'OKO-ARVOPAPERISÄILYTYKSET',
    branchNameSE: 'OKO-ARVOPAPERISÄILYTYKSET',
    branchNumber: '593929',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'ARKADIANKATU 23',
    streetAddressSE: 'ARKADIANKATU 23'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'POHJOLA/YRITYSPANKKI',
    branchNameSE: 'POHJOLA/YRITYSPANKKI',
    branchNumber: '598001',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'TEOLLISUUSKATU 1 B',
    streetAddressSE: 'TEOLLISUUSKATU 1 B'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'OKO',
    branchNameSE: 'OKO',
    branchNumber: '598403',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'INDUSTRIGATAN 1 B',
    streetAddressSE: 'TEOLLISUUSKATU 1 B'
  },
  {
    bankNameFI: 'OP YRITYSPANKKI OYJ',
    bankNameSE: 'OP FÖRETAGSBANKEN ABP',
    bankNumber: '500001',
    branchNameFI: 'OIP',
    branchNameSE: 'OIP',
    branchNumber: '599003',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'TEOLLISUUSKATU 1 B',
    streetAddressSE: 'TEOLLISUUSKATU 1 B'
  },
  {
    bankNameFI: 'OTTOLAN OSUUSPANKKI PANKIN PITKÄ NIMI',
    bankNameSE: 'OTTOLA ANDELSBANK PANKIN PITKÄ NIMI',
    bankNumber: '500032',
    branchNameFI: 'PÄÄKONTTORI',
    branchNameSE: 'HUVUDKONTOR',
    branchNumber: '500032',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00100',
    streetAddressFI: 'TEOLLISUUSKATU',
    streetAddressSE: 'TEOLLISUUSKATU'
  },
  {
    bankNameFI: 'MAKSULAN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MAKSULAN OSUUSPANKKI PITKÄ NIMI',
    bankNumber: '500050',
    branchNameFI: 'KALLVIKIN KONTTORI',
    branchNameSE: 'KALLVIKIN KONTTORI',
    branchNumber: '599872',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00550',
    streetAddressFI: 'B 2',
    streetAddressSE: 'B 2'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'PÄÄKONTTORI',
    branchNameSE: 'HUVUDKONTOR',
    branchNumber: '500094',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00520',
    streetAddressFI: 'PÄIJÄNTEENTIE 14',
    streetAddressSE: 'PÄIJÄNNEVÄGEN 14'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'CITYMARKET',
    branchNameSE: 'CITYMARKET',
    branchNumber: '500094',
    branchOrganizationIdentificationNumber: '0400',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00510',
    streetAddressFI: 'TEOLLISUUSKATU 1',
    streetAddressSE: 'INDUSTRIGATAN 1'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'KAISLARANNAN KONTTORI',
    branchNameSE: 'SÄVSTRAND KONTOR',
    branchNumber: '500652',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00550',
    streetAddressFI: 'TESTGATAN 3',
    streetAddressSE: 'TESTIKATU 3'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'KAISLARANNAN KONTTORI',
    branchNameSE: 'SÄVSTRAND KONTOR',
    branchNumber: '500666',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00550',
    streetAddressFI: 'TESTGATAN 3',
    streetAddressSE: 'TESTIKATU 3'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'TEKNINEN KONTTORI',
    branchNameSE: 'TEKNINEN KONTTORI',
    branchNumber: '500670',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00520',
    streetAddressFI: 'PÄIJÄNTEENTIE 14',
    streetAddressSE: 'PÄIJÄNNEVÄGEN 14'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'PÄÄKONTTORI',
    branchNameSE: 'HUVUDKONTOR',
    branchNumber: '500697',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00520',
    streetAddressFI: 'PÄIJÄNTEENTIE 14',
    streetAddressSE: 'PÄIJÄNNEVÄGEN 14'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'PALVELUPISTEET',
    branchNameSE: 'PALVELUPISTEET PÅ SVENSKA',
    branchNumber: '501902',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00570',
    streetAddressFI: 'TESTIKATU 4',
    streetAddressSE: 'TESTGATAN 4'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'YRITYSPANKKI',
    branchNameSE: 'FÖRETAGSBANK',
    branchNumber: '501916',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00580',
    streetAddressFI: 'TESTIKATU 5',
    streetAddressSE: 'TESTGATAN 5'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'KALLION KONTTORI',
    branchNameSE: 'BERGHÄLL KONTOR',
    branchNumber: '501947',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00610',
    streetAddressFI: 'TESTIKATU 7',
    streetAddressSE: 'TESTGATAN 7'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'ALPPILAN KONTTORI',
    branchNameSE: 'APLHYDDAN KONTOR',
    branchNumber: '501950',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00620',
    streetAddressFI: 'TESTIKATU 8',
    streetAddressSE: 'TESTGATAN 8'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'PASILAN KONTTORI',
    branchNameSE: 'BÖLE KONTOR',
    branchNumber: '501964',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00630',
    streetAddressFI: 'TESTIKATU 9',
    streetAddressSE: 'TESTGATAN 9'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'RUSKEASUON KONTTORI',
    branchNameSE: 'BRUNAKÄRR KONTOR',
    branchNumber: '501978',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00640',
    streetAddressFI: 'TESTIKATU 10',
    streetAddressSE: 'TESTGATAN 10'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'KÄPYLÄN KONTTORI',
    branchNameSE: 'KOTTBY KONTOR',
    branchNumber: '501981',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00650',
    streetAddressFI: 'TESTIKATU 66',
    streetAddressSE: 'TESTGATAN 66'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'KOSKELAN KONTTORI',
    branchNameSE: 'FORSBY KONTOR',
    branchNumber: '501995',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00660',
    streetAddressFI: 'TESTIKATU 12',
    streetAddressSE: 'TESTGATAN 12'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'KUMPULAN KONTTORI',
    branchNameSE: 'GUMTÄKT KONTOR',
    branchNumber: '502005',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00670',
    streetAddressFI: 'TESTIKATU 13',
    streetAddressSE: 'TESTGATAN 13'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'SÖRNÄISTEN KONTTORI',
    branchNameSE: 'SÖRNÄS KONTOR',
    branchNumber: '502019',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00680',
    streetAddressFI: 'TESTIKATU 14',
    streetAddressSE: 'TESTGATAN 14'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'MÄKELÄN KONTTORI',
    branchNameSE: 'BACKAS KONTOR',
    branchNumber: '502022',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00690',
    streetAddressFI: 'TESTIKATU 15',
    streetAddressSE: 'TESTGATAN 15'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'HARJUN KONTTORI',
    branchNameSE: 'ÅS KONTOR',
    branchNumber: '502036',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00700',
    streetAddressFI: 'TESTIKATU 16',
    streetAddressSE: 'TESTGATAN 16'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'PÄIJÄNTEENTIEN KONTTORI',
    branchNameSE: 'PÄIJÄNNEVÄGEN KONTOR',
    branchNumber: '502053',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00720',
    streetAddressFI: 'TESTIKATU 18',
    streetAddressSE: 'TESTGATAN 18'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'MÄKELÄN KONTTORI',
    branchNameSE: 'BACKAS KONTOR',
    branchNumber: '502067',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00730',
    streetAddressFI: 'TESTIKATU 19',
    streetAddressSE: 'TESTGATAN 19'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'HARJUN KONTTORI',
    branchNameSE: 'ÅS KONTOR',
    branchNumber: '502070',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00740',
    streetAddressFI: 'TESTIKATU 20',
    streetAddressSE: 'TESTGATAN 20'
  },
  {
    bankNameFI: 'MALLIHARJUN OSUUSPANKKI PITKÄ NIMI',
    bankNameSE: 'MALLHÖJDENS ANDELSBANK LÅNGT NAMN',
    bankNumber: '500094',
    branchNameFI: 'KAISLARANTA KONTTORI',
    branchNameSE: 'SÄVSTRAND KONTOR',
    branchNumber: '584999',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00550',
    streetAddressFI: 'TESTGATAN 3',
    streetAddressSE: 'TESTIKATU 3'
  },
  {
    bankNameFI: 'YLÄ-KAINUUN OSUUSPANKKI',
    bankNameSE: 'YLÄ-KAINUUN OSUUSPANKKI',
    bankNumber: '544209',
    branchNameFI: 'RUHTINANSALMEN VÄÄKSYNTIEN KRI',
    branchNameSE: 'RUHTINANSALMEN VÄÄKSYNTIEN KRI',
    branchNumber: '540137',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00101',
    streetAddressFI: 'OSUUSPANKKIKESKUS/VÄ2',
    streetAddressSE: 'OSUUSPANKKIKESKUS/VÄ2'
  },
  {
    bankNameFI: 'UUDENMAAN OSUUSPANKKI',
    bankNameSE: 'NYLANDS ANDELSBANK',
    bankNumber: '578800',
    branchNameFI: 'MIKONKADUN KONTTORI',
    branchNameSE: 'MIKAELSGATAN KONTOR',
    branchNumber: '500805',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00100',
    streetAddressFI: 'MIKONKATU 13',
    streetAddressSE: 'MIKAELSGATAN 13'
  },
  {
    bankNameFI: 'UUDENMAAN OSUUSPANKKI',
    bankNameSE: 'NYLANDS ANDELSBANK',
    bankNumber: '578800',
    branchNameFI: 'MIKONKADUN KONTTORI',
    branchNameSE: 'MIKAELSGATAN KONTOR',
    branchNumber: '500836',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00100',
    streetAddressFI: 'MIKONKATU 13',
    streetAddressSE: 'MIKAELSGATAN 13'
  },
  {
    bankNameFI: 'UUDENMAAN OSUUSPANKKI',
    bankNameSE: 'NYLANDS ANDELSBANK',
    bankNumber: '578800',
    branchNameFI: 'MIKONKADUN KONTTORI',
    branchNameSE: 'MIKAELSGATAN KONTOR',
    branchNumber: '500840',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00100',
    streetAddressFI: 'MIKONKATU 13',
    streetAddressSE: 'MIKAELSGATAN 13'
  },
  {
    bankNameFI: 'UUDENMAAN OSUUSPANKKI',
    bankNameSE: 'NYLANDS ANDELSBANK',
    bankNumber: '578800',
    branchNameFI: 'MIKONKADUN KONTTORI',
    branchNameSE: 'MIKAELSGATAN KONTOR',
    branchNumber: '572150',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00100',
    streetAddressFI: 'MIKONKATU 13',
    streetAddressSE: 'MIKAELSGATAN 13'
  },
  {
    bankNameFI: 'UUDENMAAN OSUUSPANKKI',
    bankNameSE: 'NYLANDS ANDELSBANK',
    bankNumber: '578800',
    branchNameFI: 'ARKADIAN KONTTORI',
    branchNameSE: 'ARKADIA KONTOR',
    branchNumber: '572210',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00100',
    streetAddressFI: 'ARKADIANKATU 23',
    streetAddressSE: 'ARKADIAGATAN 23'
  },
  {
    bankNameFI: 'UUDENMAAN OSUUSPANKKI',
    bankNameSE: 'NYLANDS ANDELSBANK',
    bankNumber: '578800',
    branchNameFI: 'ITIKSEN KONTTORI',
    branchNameSE: 'ITIS KONTOR',
    branchNumber: '572241',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00930',
    streetAddressFI: 'ITÄKATU 1-7',
    streetAddressSE: 'ÖSTERGATAN 1-7'
  },
  {
    bankNameFI: 'UUDENMAAN OSUUSPANKKI',
    bankNameSE: 'NYLANDS ANDELSBANK',
    bankNumber: '578800',
    branchNameFI: 'MIKONKADUN KONTTORI',
    branchNameSE: 'MIKAELSGATAN KONTOR',
    branchNumber: '572302',
    branchOrganizationIdentificationNumber: '0000',
    postOfficeFI: 'HELSINKI',
    postOfficeSE: 'HELSINGFORS',
    postalCode: '00100',
    streetAddressFI: 'MIKONKATU 13',
    streetAddressSE: 'MIKAELSGATAN 13'
  }
];

export const mockOfficeDetails = {
  bankNameFI: 'UUDENMAAN OSUUSPANKKI',
  bankNameSE: 'NYLANDS ANDELSBANK',
  bankSiteUrl: '/uudenmaan-osuuspankki',
  bankSiteLabel: 'Osuuspankin oma sivu',
  bankBranchDetails: [
    {
      branchNameFI: 'PÄÄKONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'HUVUDKONTOR',
      headOffice: true,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: 'OLLI LEHTILÄ',
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'ARKADIANKATU 23',
      address2: 'ARKADIAGATAN 23',
      branchNumber: '578800',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'MIKONKADUN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'MIKAELSGATAN KONTOR',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'MIKONKATU 13',
      address2: 'MIKAELSGATAN 13',
      branchNumber: '500805',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '09-1 2901',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'MIKONKADUN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'MIKAELSGATAN KONTOR',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'MIKONKATU 13',
      address2: 'MIKAELSGATAN 13',
      branchNumber: '500836',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '09-1 2901',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'MIKONKADUN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'MIKAELSGATAN KONTOR',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'MIKONKATU 13',
      address2: 'MIKAELSGATAN 13',
      branchNumber: '500840',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '09-1 2901',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'HYVINKÄÄN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '05800',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'HYVINGE KONTOR',
      headOffice: false,
      postOfficeSE: 'HYVINGE',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HYVINKÄÄ',
      address: 'HÄMEENKATU 3',
      address2: 'HÄMEENKATU 3',
      branchNumber: '506203',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'JÄRVENPÄÄN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '04400',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'TRÄSKÄNDA KONTOR',
      headOffice: false,
      postOfficeSE: 'TRÄSKÄNDA',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'JÄRVENPÄÄ',
      address: 'HELSINGINTIE 18',
      address2: 'HELSINGINTIE 18',
      branchNumber: '509209',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'KERAVAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '04200',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'KERVO KONTOR',
      headOffice: false,
      postOfficeSE: 'KERVO',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'KERAVA',
      address: 'PAASIKIVENKATU 3',
      address2: 'PAASIKIVENKATU 3',
      branchNumber: '513205',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'LOHJAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '08100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'LOHJAN KONTTORI',
      headOffice: false,
      postOfficeSE: 'LOJO',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'LOHJA',
      address: 'KAUPPAKATU 13',
      address2: 'HANDELSGATAN 13',
      branchNumber: '523604',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'NUMMELAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '03100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'NUMMELA KONTOR',
      headOffice: false,
      postOfficeSE: 'NUMMELA',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'NUMMELA',
      address: 'VIHDINTIE 3',
      address2: 'VIHDINTIE 3',
      branchNumber: '529700',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'KLAUKKALAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '01800',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'KLÖVSKOG KONTOR',
      headOffice: false,
      postOfficeSE: 'KLAUKKALA',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'KLAUKKALA',
      address: 'LIIKEKUJA 1',
      address2: 'LIIKEKUJA 1',
      branchNumber: '530017',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'PORVOON KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '06100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'BORGÅ KONTOR',
      headOffice: false,
      postOfficeSE: 'BORGÅ',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'PORVOO',
      address: 'RAUHANKATU 27',
      address2: 'FREDSGATAN 27',
      branchNumber: '535806',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'KIRKKONUMMEN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '02400',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'KYRKSLÄTT KONTOR',
      headOffice: false,
      postOfficeSE: 'KYRKSLÄTT',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'KIRKKONUMMI',
      address: 'ERVASTINTIE 1',
      address2: 'ERVASTVÄGEN 1',
      branchNumber: '555409',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'LOVIISAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '07900',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'LOVISA KONTOR',
      headOffice: false,
      postOfficeSE: 'LOVISA',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'LOVIISA',
      address: 'ALEKSANTERINKATU 8',
      address2: 'ALEXANDERSGATAN 8',
      branchNumber: '555705',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'NIKKILÄN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '04130',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'NICKBYKONTOR',
      headOffice: false,
      postOfficeSE: 'SIBBO',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'SIPOO',
      address: 'ISO KYLÄTIE 21',
      address2: 'STORA BYVÄGEN 21',
      branchNumber: '556104',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'TIKKURILAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '01300',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'DICKURSBY KONTOR',
      headOffice: false,
      postOfficeSE: 'VANDA',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'VANTAA',
      address: 'KIELOTIE 11',
      address2: 'KONVALJVÄGEN 11',
      branchNumber: '572010',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'SELLON KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '02600',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'SELLO KONTOR',
      headOffice: false,
      postOfficeSE: 'ESBO',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'ESPOO',
      address: 'LEPPÄVAARANKATU 7',
      address2: 'ALBERGAGATAN 7',
      branchNumber: '572023',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '010 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'TAPIOLAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '02100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'HAGALUND KONTOR',
      headOffice: false,
      postOfficeSE: 'ESBO',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'ESPOO',
      address: 'SAMMONSILTA 8',
      address2: 'SAMPOBRON 8',
      branchNumber: '572115',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'MIKONKADUN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'MIKAELSGATAN KONTOR',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'MIKONKATU 13',
      address2: 'MIKAELSGATAN 13',
      branchNumber: '572150',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '09-1 2901',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'ARKADIAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'ARKADIA KONTOR',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'ARKADIANKATU 23',
      address2: 'ARKADIAGATAN 23',
      branchNumber: '572210',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '09-1 2901',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'ITIKSEN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00930',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'ITIS KONTOR',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'ITÄKATU 1-7',
      address2: 'ÖSTERGATAN 1-7',
      branchNumber: '572241',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'MYYRMÄEN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '01600',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'MYRBACKA KONTOR',
      headOffice: false,
      postOfficeSE: 'VANDA',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'VANTAA',
      address: 'MYYRMÄENRAITTI 2',
      address2: 'MYYRMÄENRAITTI 2',
      branchNumber: '572290',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'MIKONKADUN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'MIKAELSGATAN KONTOR',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'MIKONKATU 13',
      address2: 'MIKAELSGATAN 13',
      branchNumber: '572302',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'ISON OMENAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '02230',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'ISON OMENAN KONTTORI',
      headOffice: false,
      postOfficeSE: 'ESBO',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'ESPOO',
      address: 'PIISPANSILTA 11',
      address2: 'BISKOPSBRON 11',
      branchNumber: '572381',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'MIKONKADUN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'MIKAELSGATAN KONTOR',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'MIKONKATU 13',
      address2: 'MIKAELSGATAN 13',
      branchNumber: '572395',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '09-1 2901',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'ARKADIAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'ARKADIA KONTOR',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'ARKADIANKATU 23',
      address2: 'ARKADIAGATAN 23',
      branchNumber: '572490',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '09-1 2901',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'ARKADIAN KONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'ARKADIA KONTOR',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'ARKADIANKATU 23',
      address2: 'ARKADIAGATAN 23',
      branchNumber: '578007',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '10',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '16',
            mins: '30'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe 10:00 - 16:30'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'HELSINGIN YRITYSPANKKI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'FÖRETAGSBANKEN I HELSINGFORS',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'ARKADIANKATU 23',
      address2: 'ARKADIAGATAN 23',
      branchNumber: '578038',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '010 005 151',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'ESPOON YRITYSKONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '02100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'FÖRETAGSBANKEN I ESBO',
      headOffice: false,
      postOfficeSE: 'ESBO',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'ESPOO',
      address: 'SAMMONSILTA 8',
      address2: 'SAMPOBRON 8',
      branchNumber: '578041',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '010 005 151',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'VANTAAN YRITYSPANKKI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '01300',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'FÖRETAGSBANKEN I VANDA',
      headOffice: false,
      postOfficeSE: 'VANDA',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'VANTAA',
      address: 'NEILIKKATIE 17',
      address2: 'NEJLIKVÄGEN 17',
      branchNumber: '578055',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '010 005 151',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'MYYRMANNIN PALVELUPISTE',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '01600',
      branchOyno: '0210',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'MYYRMANNIN PALVELUPISTE',
      headOffice: false,
      postOfficeSE: 'VANDA',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'VANTAA',
      address: 'KAUPPAKESKUS ISKOSKUJA 3',
      address2: 'KAUPPAKESKUS ISKOSKUJA 3',
      branchNumber: '578814',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '15',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        tuesday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe  9:00 - 19:00', 'la  9:00 - 15:00'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'ESPOONTORIN PALVELUPISTE',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '02770',
      branchOyno: '0230',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'ESPOONTORIN PALVELUPISTE',
      headOffice: false,
      postOfficeSE: 'ESBO',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'ESPOO',
      address: 'KAUPPAKESKUS KAMREERINTIE 3',
      address2: 'KAUPPAKESKUS KAMREERINTIE 3',
      branchNumber: '578814',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '15',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        tuesday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe  9:00 - 19:00', 'la  9:00 - 15:00'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'COLUMBUKSEN PALVELUPISTE',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00980',
      branchOyno: '0240',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'COLUMBUKSEN PALVELUPISTE',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'KAUPPAKESKUS VUOTIE 45',
      address2: 'KAUPPAKESKUS VUOTIE 45',
      branchNumber: '578814',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '15',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        tuesday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe  9:00 - 19:00', 'la  9:00 - 15:00'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'ITÄKESKUKSEN PALVELUPISTE',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00930',
      branchOyno: '0250',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'ITÄKESKUKSEN PALVELUPISTE',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'KAUPPAKESKUS ITÄKATU 7',
      address2: 'KAUPPAKESKUS ITÄKATU 7',
      branchNumber: '578814',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '15',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        tuesday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        friday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        thursday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        wednesday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        },
        monday: {
          start1: {
            hours: '09',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '19',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: false
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: ['ma - pe  9:00 - 19:00', 'la  9:00 - 15:00'],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 0500',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'RAHAHUOLTOKONTTORI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00101',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'RAHAHUOLTOKONTTORI',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'MIKONKATU 11',
      address2: 'MIKONKATU 11',
      branchNumber: '578828',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: null,
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'FALCKIN LASKENTAPISTE',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00101',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'FALCKIN LASKENTAPISTE',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'MIKONKATU 11',
      address2: 'MIKONKATU 11',
      branchNumber: '578831',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: null,
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'SECURITAKSEN LASKENTAPISTE',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00101',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE: null,
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'SECURITAKSEN LASKENTAPISTE',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI: null,
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'MIKONKATU 11',
      address2: 'MIKONKATU 11',
      branchNumber: '578845',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: null,
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    },
    {
      branchNameFI: 'OP-PRIVATE HELSINKI',
      serviceNumberFreePhoneNumber: null,
      serviceNumberLawServiceSE: null,
      postalCode: '00100',
      branchOyno: '0000',
      serviceNumberFreeHeadingSE: null,
      serviceNumberOpRealEstateSE: null,
      serviceNumberCorporateServiceSE: null,
      openingTimeAdditionalInformationSE:
        'Kolla betjäningstiderna på andelsbankens egna sidor',
      serviceNumberInsuranceServiceSE: null,
      branchNameSE: 'OP-PRIVATE HELSINGFORS',
      headOffice: false,
      postOfficeSE: 'HELSINGFORS',
      serviceNumberCallServiceSE: null,
      ceoName: null,
      openingTimeAdditionalInformationFI:
        'Katso palveluajat osuuspankin omilta sivuilta',
      serviceNumberOpRealEstateFI: null,
      bankNumber: '578800',
      serviceNumberCallServiceFI: null,
      serviceNumberSavingServiceSE: null,
      postOfficeFI: 'HELSINKI',
      address: 'ARKADIANKATU 23 C',
      address2: 'ARKADIAGATAN 23 C',
      branchNumber: '578876',
      branchOpen: {
        sunday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        saturday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        tuesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        friday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        thursday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        wednesday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        },
        monday: {
          start1: {
            hours: '00',
            mins: '00'
          },
          end2: {
            hours: '00',
            mins: '00'
          },
          end1: {
            hours: '00',
            mins: '00'
          },
          start2: {
            hours: '00',
            mins: '00'
          },
          empty: true
        }
      },
      serviceNumberCreditServiceFI: null,
      branchOpeningTime: [],
      branchLanguage: 'FI',
      contactService: false,
      serviceAvailable: false,
      serviceNumberSavingServiceFI: null,
      serviceNumberLawServiceFI: null,
      phone: '0100 5110',
      branchPhysical: null,
      serviceNumberCorporateServiceFI: null,
      serviceNumberFreeHeadingFI: null,
      serviceNumberCreditServiceSE: null,
      serviceNumberInsuranceServiceFI: null
    }
  ],
  email: 'uusimaa@op.fi'
};
